import Vue from 'vue'
import {
  ValidationProvider,
  ValidationObserver,
  extend as extendVeeValidate,
} from 'vee-validate'
import {
  required,
  email,
  alpha,
  regex,
  confirmed,
  numeric,
  min,
  min_value as minValue,
  // is_not as isNot,
  alpha_spaces as alphaSpaces,
  alpha_num as alphaNum,
} from 'vee-validate/dist/rules'
import { messages } from 'vee-validate/dist/locale/en.json'
// import CardValidator from 'card-validator'

// import {
//   states
// } from '@/lib/formHelpers'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

const isNullOrUndefined = (...values) => {
  return values.every((value) => {
    return value === null || value === undefined
  })
}

extendVeeValidate('required', {
  ...required,
  message: messages.required,
})
extendVeeValidate('email', {
  ...email,
  message: messages.email,
})
extendVeeValidate('alpha', {
  ...alpha,
  message: messages.alpha,
})

extendVeeValidate('alphaNum', {
  ...alphaNum,
  message: messages.alpha_num,
})

extendVeeValidate('alphaSpaces', {
  ...alphaSpaces,
  message: messages.alpha_spaces,
})

extendVeeValidate('regex', {
  ...regex,
  message: messages.regex,
})

extendVeeValidate('confirmed', {
  ...confirmed,
  message: messages.confirmed,
})

extendVeeValidate('numeric', {
  ...numeric,
  message: messages.numeric,
})

extendVeeValidate('minValue', {
  ...minValue,
  message: messages.min_value,
})

extendVeeValidate('min', {
  ...min,
  message: messages.min,
})

extendVeeValidate('isNot', {
  validate: (value, params) => {
    return value !== params.value
  },
  params: ['value'],
  message: messages.is_not,
})

extendVeeValidate('decimal', {
  validate: (value, { decimals = '*', separator = '.' }) => {
    if (isNullOrUndefined(value) || value === '') {
      return false
    }

    // if (Array.isArray(value)) {
    //   return value.every(val => validate(val, { decimals, separator }))
    // }

    // if is 0.
    if (Number(decimals) === 0) {
      return /^-?\d*$/.test(value)
    }

    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`
    const tempRegex = new RegExp(
      `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`
    )

    if (!tempRegex.test(value)) {
      return false
    }

    const parsedValue = parseFloat(value)

    // eslint-disable-next-line
    return parsedValue === parsedValue
  },
  params: ['decimals', 'separator'],
})

extendVeeValidate('phone', {
  validate: (value) => {
    return value.replace(/\D+/g, '').length === 10
  },
  message: 'Please enter a valid phone number',
})

extendVeeValidate('formName', {
  validate: (value) => {
    return /^[a-zA-Z\-' ]*$/i.test(value)
  },
  message: "The {_field_} field must contain only letters, ', and -",
})

extendVeeValidate('studentIdEmailDomain', {
  // if student id and they are NOT A PARENT, evaluate student id email domain
  validate: (value, params) => {
    const customerEmailDomain = params.validationEmail
      .split('@')[1]
      .trim()
      .toLowerCase()
    const customerEmailSplit = customerEmailDomain.split('.')
    const customerDomainToMatch = `${
      customerEmailSplit[customerEmailSplit.length - 2]
    }.${customerEmailSplit[customerEmailSplit.length - 1]}`
    if (typeof params.validationDomain === 'string') {
      if (
        params.validationDomain.length > 0 &&
        params.validationDomain !== customerDomainToMatch
      ) {
        return false
        // tempValidityHandler.studentIdEmailDomain = true
      }
    }
    return true
  },
  params: ['validationDomain', 'validationEmail'],
  message: 'The email is not valid for this Student ID',
})

extendVeeValidate('validFacultyEmail', {
  validate: (value, params) => {
    if (params.customerEmailIndex === -1) {
      return false
      // tempValidityHandler.facultyEmail = true
    }
    return true
  },
  params: ['customerEmailIndex'],
})

// extendVeeValidate('state', {
//   validate: value => {
//     let valid = false
//     const state = value || '' // make sure state is a string
//     if (state.length === 2) {
//       const matchedAbb = states.filter(
//         a => a.value.toLowerCase() === state.toLowerCase(),
//       )
//       if (matchedAbb[0]) valid = true
//     } else if (state.length >= 4) {
//       const matchedState = states.filter(
//         a => a.name.toLowerCase() === state.toLowerCase(),
//       )
//       if (matchedState[0]) valid = true
//     }
//     return valid
//   },
//   message: 'The {_field_} field must be a state',
// })

extendVeeValidate('notInside', {
  // (value, set) {
  validate: (value, params) => {
    return params.set.indexOf(value) === -1
  },
  params: ['set'],
  message: 'The {_field_} field must not be inside the list',
})

extendVeeValidate('minIfOne', {
  // (value, length) {
  validate: (value, args) => {
    if (value.length > 0) {
      return value.length >= args.length
    }
    return true
  },
  params: ['length'],
  message: 'A {_field_} field must be longer than {length} characters',
})

// extendVeeValidate('creditCardNumber', {
//   validate: (value, params) => {
//     const validation = CardValidator.number(value)
//     if (validation) {
//       if (validation.isValid) {
//         const c = validation.card.niceType
//         if (c === 'American Express' || c === 'Mastercard' || c === 'Visa') {
//           if (params.invalidCard) return 'Invalid card number'
//           if (params.declined) {
//             return 'Card declined. Please contact your card issuer'
//           }
//           return true
//         }
//       }
//     }
//     return 'Please enter a valid credit card number'
//   },
//   params: ['invalidCard', 'declined'],
// })

// extendVeeValidate('creditCardExpiration', {
//   validate: value => {
//     const dateValidation = CardValidator.expirationDate(value)
//     if (dateValidation) {
//       if (dateValidation.isValid) return true
//     }
//     return 'Please enter a valid date'
//   },
// })

// extendVeeValidate('creditCardCVV', {
//   validate: (value, params) => {
//     if (typeof value === 'string') {
//       if (value.length > 2 && value.length < 5) {
//         const validation = CardValidator.number(params.creditCardNumber)
//         if (validation) {
//           if (validation.isValid) {
//             let codeLength = 3
//             if (validation.card.niceType === 'American Express') codeLength = 4
//             const codeValidation = CardValidator.cvv(value, codeLength)
//             if (codeValidation) {
//               if (codeValidation.isValid) {
//                 return true
//               }
//             }
//             return 'Please enter a valid security code'
//           }
//           return true // the card number is not valid, there is another error in the view
//         }
//         return true // the card number is not valid, there is another error in the view
//       }
//       return 'Please enter a valid security code'
//     }
//   },
//   params: ['creditCardNumber'],
// })
